var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoPublishImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 222,
    viewBox: "0 0 300 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 222,
    fill: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8656_11693",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 130,
    y: 91,
    width: 40,
    height: 40
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 91,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8656_11693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.333 127.667C136.944 127.667 135.764 127.18 134.792 126.208C133.819 125.236 133.333 124.055 133.333 122.667V99.3333C133.333 97.9444 133.819 96.7638 134.792 95.7916C135.764 94.8194 136.944 94.3333 138.333 94.3333H161.667C163.056 94.3333 164.236 94.8194 165.208 95.7916C166.181 96.7638 166.667 97.9444 166.667 99.3333V122.667C166.667 124.055 166.181 125.236 165.208 126.208C164.236 127.18 163.056 127.667 161.667 127.667H138.333ZM138.333 124.333H161.667C162.139 124.333 162.534 124.173 162.853 123.853C163.173 123.534 163.333 123.139 163.333 122.667V99.3333C163.333 98.861 163.173 98.4649 162.853 98.1449C162.534 97.826 162.139 97.6666 161.667 97.6666H138.333C137.861 97.6666 137.465 97.826 137.145 98.1449C136.826 98.4649 136.667 98.861 136.667 99.3333V122.667C136.667 123.139 136.826 123.534 137.145 123.853C137.465 124.173 137.861 124.333 138.333 124.333ZM140 121L146.667 114.333L149.667 117.292L153.333 112.667L160 121H140ZM143.333 107.667C142.417 107.667 141.632 107.34 140.98 106.687C140.327 106.034 140 105.25 140 104.333C140 103.417 140.327 102.632 140.98 101.98C141.632 101.327 142.417 101 143.333 101C144.25 101 145.035 101.327 145.688 101.98C146.341 102.632 146.667 103.417 146.667 104.333C146.667 105.25 146.341 106.034 145.688 106.687C145.035 107.34 144.25 107.667 143.333 107.667Z",
    fill: "#999999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPublishImg);
export default __webpack_public_path__ + "static/media/noPublishImg.8592f8d2e991f230af5c3cde227ae788.svg";
export { ForwardRef as ReactComponent };